export default {"src":"/_next/static/media/pillWithBox_40.897f13d8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};